<template>
    <div class="toegewezen-bijdragen-table">
        <table
            v-if="toekenningen.length"
            aria-live="polite"
        >
            <thead class="toegewezen-bijdragen-table__header">
                <tr>
                    <th scope="col">{{ t('toegewezen_bijdragen.table.project_title') }}</th>
                    <th scope="col">{{ t('toegewezen_bijdragen.table.requestee') }}</th>
                    <th scope="col">{{ t('toegewezen_bijdragen.table.director') }}</th>
                    <th scope="col">{{ t('toegewezen_bijdragen.table.screenwriter') }}</th>
                    <th scope="col">{{ t('toegewezen_bijdragen.table.category') }}</th>
                    <th scope="col">{{ t('toegewezen_bijdragen.table.subsidy_type') }}</th>
                    <th scope="col">{{ t('toegewezen_bijdragen.table.amount') }}</th>
                    <th scope="col">{{ t('toegewezen_bijdragen.table.date') }}</th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="(toekenning, key) in toekenningen"
                    :key="key"
                    class="toegewezen-bijdragen-table__row"
                >
                    <td>{{ toekenning?.title }}</td>
                    <td>{{ toekenning?.aanvrager }}</td>
                    <td>{{ toekenning?.regisseur }}</td>
                    <td>{{ toekenning?.scenarist }}</td>
                    <td>{{ toekenning?.toegewezenBijdrageCategory?.[0]?.title }}</td>
                    <td>{{ toekenning?.toegewezenBijdragesoort?.[0]?.title }}</td>
                    <td class="toegewezen-bijdragen-table__nowrap"><span class="sr-only">€{{ toekenning?.bedrag }}</span><span aria-hidden="true">€{{ n(parseInt(toekenning?.bedrag, 10)) }}</span></td>
                    <td class="toegewezen-bijdragen-table__nowrap"><time :datetime="d(parseISO(toekenning?.date))">{{ d(parseISO(toekenning?.date), 'dateShort') }}</time></td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script setup>
import { parseISO } from 'date-fns';

defineProps({
    toekenningen: {
        type: Array,
        default() { return []; }
    }
});

const { t, d, n } = useI18n();
</script>

<style lang="less" src="./ToegewezenBijdragenTable.less" />
